import { QueryClient } from "@tanstack/react-query";

// The talent SPA's single TanStack Query client — same config as web's
// (frontend/web/src/lib/query-client.ts). Pusher is the source of truth for
// freshness: the worker pushes `seller.message` / `seller.thread.update` over the
// talent's private channel, so queries don't poll or refetch on focus. The
// Pusher→cache dispatcher (seller-stream-dispatcher.ts) patches the cache on a
// message and invalidates the affected detail on a thread.update. The one gap is a talent
// that is NOT on screen (the app subscribes to a single channel): the thread list and the chats
// go stale on a clock (THREAD_STALE_MS) and are marked stale when the tester leaves a talent
// (watchTalentSwitches), so they re-read when that talent is opened again. A remount refetch,
// never a poll. See frontend/seller/ARCHITECTURE.md for the data-flow contract.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
